import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAddModal, toggleNeedRefresh } from '../../store/notificartionsTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

import './Notifications.css';

function AddNewNotification() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.notifications.addModalOpen);

  const [formData, setFormData] = useState({
    gender_of_the_sender: '',
    gender_of_the_recipient: '',
    content_pl: '',
    content_eng: '',
    enabled: false,
    push_enabled: false,
    notification_type: '',
  });

  const [notificationTypes, setNotificationTypes] = useState([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    // Pobierz opcje z API po otwarciu modala
  useEffect(() => {
    if (isModalOpen) {
      ApiService.getNotificationTypes()
        .then((types) => setNotificationTypes(types))
        .catch(() => setNotificationTypes([]));
    }
  }, [isModalOpen]);

  useEffect(() => {
    const isValid = formData.content_pl.trim() !== '' &&
                    formData.content_eng.trim() !== '' &&
                    formData.enabled !== null &&
                    formData.push_enabled !== null &&
                    formData.notification_type.trim() !== '';
    setIsSubmitDisabled(!isValid);
  }, [formData]); // Monitoruj zmiany w `formData`

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();      
    try {
      const notifData = {
        ...(formData.gender_of_the_sender && {genderOfTheSender: formData.gender_of_the_sender}),
        ...(formData.gender_of_the_recipient && {genderOfTheRecipient: formData.gender_of_the_recipient}),
        contentEng: formData.content_eng,
        contentPl: formData.content_pl,
        enabled: formData.enabled,
        pushEnabled: formData.push_enabled,
        notificationTypeEnum: formData.notification_type 
      };

      const response = await ApiService.addNewNotification(notifData);
      console.log('Nowa notyfikacja została dodana:', response);

      dispatch(toggleAddModal());
      dispatch(toggleNeedRefresh());
    } catch (error) {
      console.error('Błąd podczas dodawania nowej notyfikacji:', error);
    }
  };

  const handleCloseModal = () => {
    dispatch(toggleAddModal());
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
      <h2>Dodaj notyfikację</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="notification_type">Typ notyfikacji</label>
          <br></br>
            <select
              id="notification_type"
              name="notification_type"
              value={formData.notification_type}
              onChange={handleInputChange}
              required
            >
            <option value="">Wybierz kategorię</option>
              {notificationTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.name}
                </option>
              ))}
            </select>
        </div>
        {formData.notification_type && (
          <div style={{ marginTop: 8, fontSize: 13, color: '#666', whiteSpace: 'pre-line'}}>
            {
              notificationTypes.find(t => t.value === formData.notification_type)?.description
            }
          </div>
        )}
        {((formData.notification_type === "INVITATION_TO_FRIEND") ||
            (formData.notification_type === "INVITATION_TO_TRAINING") ||
            (formData.notification_type === "INVITATION_TO_CHAT") ||
            (formData.notification_type === "TRAINING_CANCELED") ||
            (formData.notification_type === "TRAINING_START") ||
            (formData.notification_type === "TRAINING_INVITATION_ACCEPTED") ||
            (formData.notification_type === "TRAINING_INVITATION_REJECTED") ||
            (formData.notification_type === "TRAINING_INVITATION_CANCELED")
        ) && (
            <div className="flex-space-around">
              {((formData.notification_type === "INVITATION_TO_FRIEND") ||
                      (formData.notification_type === "INVITATION_TO_TRAINING") ||
                      (formData.notification_type === "INVITATION_TO_CHAT") ||
                      (formData.notification_type === "TRAINING_CANCELED") ||
                      (formData.notification_type === "TRAINING_INVITATION_ACCEPTED") ||
                      (formData.notification_type === "TRAINING_INVITATION_REJECTED") ||
                      (formData.notification_type === "TRAINING_INVITATION_CANCELED")
                  ) && (<div className= "flex-content">
                <label htmlFor="gender_of_the_sender">Płeć wysyłającego</label>
                <br></br>
                <select
                  id="gender_of_the_sender"
                  name="gender_of_the_sender"
                  value={formData.gender_of_the_sender}
                  onChange={handleInputChange}>
                    <option value="">Wybierz płeć</option>
                    <option key="FEMALE" value="FEMALE">Kobieta</option>
                    <option key="MALE" value="MALE">Mężczyzna</option>
                </select>
              </div>)}
              {((formData.notification_type === "INVITATION_TO_FRIEND") ||
                (formData.notification_type === "INVITATION_TO_TRAINING") ||
                (formData.notification_type === "INVITATION_TO_CHAT") ||
                (formData.notification_type === "TRAINING_CANCELED") ||
                (formData.notification_type === "TRAINING_START") ||
                (formData.notification_type === "TRAINING_INVITATION_REJECTED") ||
                (formData.notification_type === "TRAINING_INVITATION_CANCELED")
                ) && ( <div>
                    <label htmlFor="gender_of_the_recipient">Płeć odbiorcy</label>
                    <br></br>
                    <select
                    id="gender_of_the_recipient"
                    name="gender_of_the_recipient"
                    value={formData.gender_of_the_recipient}
                    onChange={handleInputChange}>
                      <option value="">Wybierz płeć</option>
                      <option key="FEMALE" value="FEMALE">Kobieta</option>
                      <option key="MALE" value="MALE">Mężczyzna</option>
                </select>
              </div> )}
            </div>
        )}
        <div></div>
        <div>
          <label htmlFor="content_pl">Treść w języku polskim</label>
          <input
            type="text"
            id="content_pl"
            name="content_pl"
            value={formData.content_pl}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="content_eng">Treść w języku angielskim</label>
          <input
            type="text"
            id="content_eng"
            name="content_eng"
            value={formData.content_eng}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="flex-space-around">
          <div>
            <input
              type="checkbox"
              name="enabled"
              checked={formData.enabled}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  enabled: e.target.checked,
                }))
              }

            />
            <label htmlFor="enabled">Aktywność notyfikacji</label>
          </div>
          <div>
            <input
              type="checkbox"
              name="push_enabled"
              checked={formData.push_enabled}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  push_enabled: e.target.checked,
                }))
              }
            />
            <label htmlFor="push_enabled">Powiadomienie PUSH</label>
          </div>
        </div>
        <div className="modal-margin-top-20">
          <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
            Anuluj
          </button>
          <button type="submit" disabled={isSubmitDisabled}>
            Dodaj
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default AddNewNotification;
